import {
  ActiveModes,
  Address,
  OccCustomerConsignment,
  PaymentMode,
  ReceiptType,
  SelectedPaymentMode,
  Service,
  TimeSlot,
} from '@checkout-v2/const';
import { CustomOrder } from '@order/const';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';

export const CHECKOUT_FEATURE = 'checkout';
export const RECEIPT_TYPES = '[Checkout] Receipt types';
export const TIME_SLOTS = '[Checkout] Time slots';
export const TIME_SLOTS_CUSTOM_DATE = '[Checkout] Time slots custom date';
export const SAVED_ADDRESS_LIST = '[Checkout] Saved address list';
export const USER_PICKUP_SHOP_LIST = '[Checkout] User pickup shop list';
export const SERVICES = '[Checkout] Services';
export const PAYMENT_MODE_LIST = '[Checkout] Payment mode list';
export const ACTIVE_PAYMENT_MODE = '[Checkout] Active payment mode';
export const CUSTOMER_CONSIGNMENT = '[Checkout] Customer Consignment';
export const PLACED_ORDER_PROCESS_ID = 'placeOrder';

export interface StateWithCustomCheckout {
  [CHECKOUT_FEATURE]: CustomCheckoutState;
}

export interface CustomCheckoutState {
  receiptTypes: StateUtils.LoaderState<ReceiptType[]>;
  activeModes: ActiveModes;
  timeSlots: StateUtils.LoaderState<TimeSlot[]>;
  timeSlotsForCustomDate: StateUtils.LoaderState<TimeSlot[]>;
  customDate: string | undefined;
  addressList: StateUtils.LoaderState<Address[]>;
  userPickupShopList: StateUtils.LoaderState<Pos[]>;
  services: StateUtils.LoaderState<Service[]>;
  orderDetails: CustomOrder;
  customerConsignment: StateUtils.LoaderState<OccCustomerConsignment>;
  paymentModesList: StateUtils.LoaderState<PaymentMode[]>;
  activePaymentMode: StateUtils.LoaderState<SelectedPaymentMode | undefined>;
}
